import type { DateRangePresetId } from '@/components/molecules/DateRangePicker/DateRangePresets';
import type { HealthParameterKey } from '@/domain/health';

/** Default preset for Health development and overview charts. */
export const HEALTH_DEFAULT_DATE_RANGE_PRESET_ID: DateRangePresetId = 'last4weeks';

/** URL key for the Health dashboard overview (`health-overview-from`, `health-overview-to`). */
export const HEALTH_OVERVIEW_DATE_RANGE_URL_KEY = 'health-overview';

/**
 * URL prefix per parameter for development chart date range (`{key}-from`, `{key}-to`).
 * Same pattern as Behavior Tilt (`tilt-from`, `tilt-to`). Keys align with detail routes where possible.
 */
const HEALTH_DEVELOPMENT_DATE_RANGE_KEY_BY_PARAMETER: Partial<Record<HealthParameterKey, string>> =
    {
        maturity: 'maturation',
        finDamage: 'fin-status',
        emaciation: 'emaciation',
        cataract: 'cataract',
        scaleLoss: 'scale-loss',
        skinBleeding: 'skin-bleeding',
        deformity: 'spine',
        deformedJaw: 'jaw',
        gillLid: 'gill-lid',
        eyeDamage: 'eye-damage',
        bodyWounds: 'body-wounds',
        snoutWounds: 'snout-wounds',
    };

export function getHealthDevelopmentDateRangeKey(healthParameterKey: HealthParameterKey): string {
    return HEALTH_DEVELOPMENT_DATE_RANGE_KEY_BY_PARAMETER[healthParameterKey] ?? healthParameterKey;
}
